import { FirstSectionCart } from "./components/firstSection";


export const CartPage = () => {
    return (
        <>
            <FirstSectionCart />

        </>
    );
};
